import { createSelector } from '@reduxjs/toolkit';

export const websocketSelector = (state) => state.websocket;
export const isWsConnectedSelector = createSelector(
  websocketSelector,
  (websocketState) => websocketState.connected,
);
export const useWebSocketSelector = createSelector(
  websocketSelector,
  (websocketState) => websocketState.useWebSocket,
);

export const connectErrorSelector = createSelector(
  websocketSelector,
  (websocketState) => websocketState.connectError,
);
